<template>
    <div class="relative w-full pt-24 rounded-b-2xl bg-white">
        <div class="flex flex-wrap">
            <section class="w-full">
                <div class="bg-white rounded-b-2xl">
                    <div class="self-gutter">
                        <div class="self-gutter-y self-content">
                            <div class="pt-24 login-intro">
                                <p v-html="$t('login.intro')"></p>
                                <button class="self-btn-primary mx-auto my-40" @click="login()" v-if="!isLoggedIn">
                                    {{ $t('login.submit') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <section class="relative w-full">
            <div class="self-gutter">
                <LogoIllustrationSVG class="extra-logo-illustration absolute bottom-0 right-0" alt="illustration" />
                <div class="self-content min-h-page"></div>
            </div>
        </section>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import store from '../../store';
import router from '../../router';
import LogoIllustrationSVG from '@/assets/static/icons-src/logo-illustration.svg';
import AuthService from '@/services/auth-service';
const auth = new AuthService();
@Component({
    components: {
        LogoIllustrationSVG
    }
})
export default class Login extends Vue {
    public isLoggedIn = false;

    login() {
        auth.updateLanguage();
        auth.login();
    }

    logout() {
        auth.updateLanguage();
        auth.logout();
    }

    // ============ Lifecycle methods ==========

    async mounted() {
        if (store.state.logOut === true) {
            this.logout();
        } else {
            auth.getUser().then(async (user) => {
                if (user) {
                    const customerId = user?.profile?.customer_id;
                    if (!customerId?.length) {
                        const locale = this.$i18n.locale;
                        const registrationUrl =
                            locale === 'en' ? 'https://www.estravel.ee/en/customer-account/' : 'https://www.estravel.ee/kliendikonto/';
                        window.location.href = registrationUrl;
                        this.isLoggedIn = false;
                        return;
                    }
                    this.isLoggedIn = !user.expired;
                    store.commit('setLoginInfo', user);
                    await store
                        .dispatch('authenticateUser')
                        .then((success: boolean) => {
                            // Check if there's a customer info loading error first
                            if (store.getters.getCustomerInfoLoadingError) {
                                router.replace(`/${this.$i18n.locale}/customer-info-error`);
                            } else if (success && store.getters.shouldAskForPersonalDetails) {
                                router.push(`/${this.$i18n.locale}/info`);
                            } else if (success) {
                                router.push(`/${this.$i18n.locale}/dashboard`);
                            } else {
                                this.isLoggedIn = false;
                            }
                        })
                        .catch((error: any) => {
                            alert(error);
                        });
                } else {
                    // If user gets directed to the app from estravel.ee, he/she is already logged in
                    const referrer = document.referrer;
                    if (referrer?.includes('estravel.ee') && !this.isLoggedIn) {
                        this.login();
                    }
                }
            });
        }
    }
}
</script>
<style scoped>
.min-h-page {
    min-height: calc(100vh - 584px);
}
</style>
